import type { ReactNode } from 'react'

interface SurfaceCardProps {
  children: ReactNode
  className?: string
  padding?: string
}

export function SurfaceCard({ children, className = '', padding = 'p-6' }: SurfaceCardProps) {
  return (
    <div className={`rounded-2xl border border-line bg-white shadow-card ${padding} ${className}`}>
      {children}
    </div>
  )
}
